export const statsCardStyles = `
.opt-stats-card {
    background: var(--surface);
    border-radius: var(--radius-md);
    padding: var(--spacing-md);
    box-shadow: var(--shadows-sm);
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
}

.opt-stats-card-icon {
    width: 48px;
    height: 48px;
    border-radius: var(--radius-md);
    background: var(--background-light);
    display: flex;
    align-items: center;
    justify-content: center;
}

.opt-stats-card-icon i {
    font-size: 24px;
}

.opt-stats-card-content {
    flex: 1;
}

.opt-stats-card-title {
    font-size: var(--typography-fontSize-sm);
    color: var(--text-secondary);
    margin-bottom: var(--spacing-xs);
}

.opt-stats-card-value {
    font-size: var(--typography-fontSize-xl);
    font-weight: var(--typography-fontWeight-bold);
    color: var(--text-primary);
}

.opt-stats-card-loading {
    height: 24px;
    width: 80px;
    background: var(--background-light);
    border-radius: var(--radius-sm);
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
`;